<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<app-image-url-item
  *ngIf="imageItem.type === TaskDatumType.IMAGE_URL"
  [imageItem]="imageItem">
</app-image-url-item>
<div *ngIf="imageItem.type !== TaskDatumType.IMAGE_URL"
  class="image_container slider-border" fxLayoutAlign="center center">
  <img [src]="imagePath" style="height: 160px" />
</div>
